window.PlummeI18n.register('en', {
  'bank.archive.filter.postingType': 'Posting type',
  'bank.archive.filter.purchase': 'Purchase',
  'bank.archive.filter.otherSale': 'Other sale',
  'bank.archive.filter.payment': 'Payment',
  'bank.archive.filter.manualPosting': 'Manual posting',
  'bank.archive.filter.bankPosting': 'Bank posting',
  'bank.archive.filter.publicPayment': 'Payroll and taxes',
  'bank.archive.filter.ignored': 'Ignored bank line',
  'bank.archive.filter.documentation': 'Documentation',
  'bank.archive.filter.missingAttachment': 'Missing voucher',
  'bank.archive.filter.hasAttachment': 'Has voucher',
  'bank.archive.sort.label': 'Sort postings',
  'bank.archive.sort.statementOrder': 'Bank statement order',
  'bank.archive.sort.dateDesc': 'Date: newest first',
  'bank.archive.sort.dateAsc': 'Date: oldest first',
  'bank.archive.sort.amountDesc': 'Amount: highest first',
  'bank.archive.sort.amountAsc': 'Amount: lowest first',
});
